import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

export enum PeriodTypes {
  // hour = 'hour',
  // day = 'day',
  week = 'week',
  month = 'month',
  year = 'year',
  today = 'today',
}

export const getPeriod = (
  variant: PeriodTypes,
  period?: [string, string],
): [string, string, string] => {
  dayjs.extend(utc);

  switch (variant) {
    // case PeriodTypes.hour:
    //   return [
    //     dayjs.utc().subtract(1, 'hours').format('YYYY-MM-DD HH:mm:ss'),
    //     dayjs.utc().format('YYYY-MM-DD HH:mm:ss'),
    //     PeriodTypes.hour,
    //   ];
    // case PeriodTypes.day:
    //   return [
    //     dayjs.utc().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
    //     dayjs.utc().format('YYYY-MM-DD HH:mm:ss'),
    //     PeriodTypes.day,
    //   ];
    case PeriodTypes.week:
      return [
        dayjs.utc().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
        dayjs.utc().format('YYYY-MM-DD HH:mm:ss'),
        PeriodTypes.week,
      ];
    case PeriodTypes.month:
      return [
        dayjs.utc().subtract(1, 'months').format('YYYY-MM-DD HH:mm:ss'),
        dayjs.utc().format('YYYY-MM-DD HH:mm:ss'),
        PeriodTypes.month,
      ];
    case PeriodTypes.year:
      return [
        dayjs.utc().subtract(1, 'years').format('YYYY-MM-DD HH:mm:ss'),
        dayjs.utc().format('YYYY-MM-DD HH:mm:ss'),
        PeriodTypes.year,
      ];
    // case PeriodTypes.period:
    //   return [
    //     dayjs(period![0]).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
    //     dayjs(period![1]).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
    //     PeriodTypes.period,
    //   ];
    case PeriodTypes.today:
      return [
        dayjs().startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
        dayjs.utc().format('YYYY-MM-DD HH:mm:ss'),
        PeriodTypes.today,
      ];
    default:
      return [
        dayjs.utc().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
        dayjs.utc().format('YYYY-MM-DD HH:mm:ss'),
        PeriodTypes.week,
      ];
  }
};
